import React from "react";
import { Fetcher } from "../../components/Fetcher";
import { getReport } from "../../services/api/reports.api";
import { hasPowFeature, POW_FEATURES } from "../../services/powFeatures.service";
import { ReportEdit } from "../../components/Reports/ReportsEdit";
import { ReportDetails } from "../../components/Reports/ReportsDetails";

interface ReportDetailsPageProps {
	// product id
	productId: string;
	//Report Id
	reportId: string;
}

/**
 * Page to display report details and allow configuration editing
 * @param props
 */
export const ReportDetailsPage = (props: ReportDetailsPageProps) => {
	return (
		<div>
			<Fetcher action={getReport(props.productId, props.reportId!)}>
				{({ data }) =>
					hasPowFeature(POW_FEATURES.paReports_Admin) ? (
						<ReportEdit productId={props.productId} report={data}></ReportEdit>
					) : (
						<ReportDetails report={data}></ReportDetails>
					)
				}
			</Fetcher>
		</div>
	);
};
